/** ProseMirror schema for section blocks (spec §7.4.2). Tables come after spike S2. */
import { Schema } from "prosemirror-model";
import { schema as basic } from "prosemirror-schema-basic";
import { addListNodes } from "prosemirror-schema-list";

const nodes = addListNodes(basic.spec.nodes, "paragraph block*", "block")
  // drop image and code_block: images are blocks, code lives in code blocks (spec §5.2)
  .remove("image")
  .remove("code_block");

export const pmSchema = new Schema({
  nodes,
  marks: basic.spec.marks.append({
    strike: {
      parseDOM: [{ tag: "s" }, { tag: "del" }, { style: "text-decoration=line-through" }],
      toDOM: () => ["s", 0],
    },
  }),
});
